module.exports = __webpack_public_path__ + "img/a1.b6a605b4.png";